export const maxDisplayedFullWidthTabs = 5;
